import React, { useState } from "react";
import { PopupBlock } from "./styled";
import { Heading, Text } from "../../../styled";
import { createEventObjectFunction } from "../../../utils/helper";
import { onboardingFillEventAmplitude } from "../../../amplitude/events";
import { onboardingFillEvent } from "../../../firebaseAnalytics/events";
import { analytics } from "../../../firebaseAnalytics";
import { useSelector } from "react-redux";

const Popup = ({ data, cb, eventFillName }) => {
  const [activeButton, setActiveButton] = useState(null);

  const landingId = useSelector((state) => state.questions.landingId);

  const handleButtonClick = (index) => {
    setActiveButton(index);
    const eventObj = createEventObjectFunction(eventFillName, null, landingId);
    // Событие №4 fill
    onboardingFillEvent(analytics, eventObj);
    onboardingFillEventAmplitude(eventObj);
    if (cb) {
      setTimeout(() => {
        cb();
      }, 500);
    }
  };

  return (
    <PopupBlock>
      <PopupBlock.Window>
        <PopupBlock.Title>
          <Heading.Third>{data.title}</Heading.Third>
        </PopupBlock.Title>
        <PopupBlock.Buttons>
          <PopupBlock.Button
            onClick={() => handleButtonClick(0)}
            active={activeButton === 0}
          >
            <Text>No</Text>
          </PopupBlock.Button>
          <PopupBlock.Button
            onClick={() => handleButtonClick(1)}
            active={activeButton === 1}
          >
            <Text>Yes</Text>
          </PopupBlock.Button>
        </PopupBlock.Buttons>
      </PopupBlock.Window>
    </PopupBlock>
  );
};

export default Popup;
